import React, { Component } from 'react';
import cn from 'classnames';
import IconTooltip from '~/components/iconTooltip/iconTooltip';
import Spinner from '~/components/spinner/spinner';

export default class DownloadIcon extends Component {
  state = {
    downloading: false
  };

  onClick = () => {
    this.setState({
      downloading: true
    });

    this.props.onClick();

    setTimeout(() => {
      this.setState({
        downloading: false
      });
    }, 2500);
  };

  render() {
    if (this.state.downloading) {
      return <Spinner />;
    }

    return (
      <IconTooltip
        className={cn(this.props.className, 'pointer')}
        icon="download-circle"
        text="Download"
        onClick={this.onClick}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/downloadIcon/downloadIcon.jsx